import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { CustomerSetBuilderService } from './../../../services/customer/customer-set-builder.service';
import { Component, Input, OnInit, ViewChild, SimpleChanges } from '@angular/core';
import { CustomerSetImportService } from 'app/services/customer/customer-set-import.service';

@Component({
  selector: 'app-customer-set-execution-list',
  templateUrl: './customer-set-execution-list.component.html',
  styleUrls: ['./customer-set-execution-list.component.css']
})
export class CustomerSetExecutionListComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  noFilter = KontableComponent.NoFilter;
  @Input() queryId: number;
  @ViewChild('table') table: KontableComponent;

  showDetail: boolean;
  actualRow;

  constructor(
    public customerSetBuilderService: CustomerSetBuilderService,
    public customerSetImportService: CustomerSetImportService,
  ) { }

  ngOnInit() {
    if (this.queryId) {
      this.customerSetBuilderService.getqueryId(this.queryId);
    }
    this.customerSetBuilderService.list()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.queryId) {
      this.customerSetBuilderService.getqueryId(changes.queryId.currentValue);
      this.table.refresh();
    }
  }

  ngOnDestroy() {
    this.customerSetBuilderService.getqueryId(null);
  }


  openDetailDialog(row) {
    this.customerSetBuilderService.getListQueryExecuted(row.id_query, row.version, row.job_id).subscribe(res => {
      console.log(res.data[0])
      this.actualRow = res.data[0];
      console.log(this.actualRow)
      this.showDetail = true;
    })
  }

  closeDetailDialog() {
    this.actualRow = null;
    this.showDetail = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-execution-list/customer-set-execution-list.component.ts